import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, effect, inject, signal } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { DocumentStatusType } from '../../../../generated/generated-types';
import { WidgetDeliveryItemListComponent } from '../widget-delivery-item-list/widget-delivery-item-list.component';

@Component({
  selector: 'app-formly-delivery-item-widget',
  templateUrl: './formly-delivery-item-widget.component.html',
  standalone: true,
  imports: [
    CommonModule,
    WidgetDeliveryItemListComponent,
  ]
})
export class FormlyDeliveryItemWidgetListComponent extends FieldType<FieldTypeConfig> implements OnInit {

  documentId: string;
  documentStatus = signal<DocumentStatusType>(null);

  // @ViewChild('addEditDeliveryItemWidget')
  // addEditDeliveryItemWidget: WidgetDeliveryItemListComponent;

  cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    super();
    effect(() => {
      let status = this.formState?.detailComponent?.detailModelSig()?.status;
      if (status) {
        this.documentStatus.set(status);
      }
    });
  }

  ngOnInit(): void {
    if (this.model) {
      this.documentId = this.model[this.key as string]; // The key is comming from the formly field definition[fallbacks]
    }

    this.formControl.valueChanges.subscribe((model: string) => {
      let docId = model;
      if (this.documentId != docId) {
        this.documentId = docId;
        this.cdRef.detectChanges();
      }
    });
  }

}
